import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { ELevelResult, } from 'Shared/types';
import { encodeStringToBase64 } from 'Common/utils';
import ArrowLink from 'Common/components/ArrowLink/ArrowLink';
import useRouter, { PhenotypeViewRoute, } from 'Router/index';
const LinkToPhenotypeView = ({ phenotypeId, phenotypeName, levelResult, label, title, className, referrerData, datasetVersionId, handleClick, }) => {
    const levelResultForLink = FEATURE_FLAGS.VLR_TAB_ENABLED ? levelResult : ELevelResult.Gene;
    const { getLocation, getParams } = useRouter();
    const { pathname } = getLocation();
    const { datasetVersionId: datasetVersionIdParam } = getParams();
    const phenotypeViewPath = PhenotypeViewRoute.getPath({
        phenotypeId,
        encodedPhenotypeName: encodeStringToBase64(phenotypeName),
        datasetVersionId: datasetVersionId || datasetVersionIdParam,
        levelResult: levelResultForLink,
    });
    const route = useMemo(() => ({
        pathname: phenotypeViewPath,
        state: {
            referrerURI: pathname,
            referrerData,
        },
    }), [pathname, phenotypeViewPath, referrerData]);
    return (_jsx(ArrowLink, Object.assign({ route: route, className: className, title: title, handleClick: handleClick }, { children: label || 'Phenotype:' }), void 0));
};
export default memo(LinkToPhenotypeView);
